import React, { useState } from 'react'
import { useTranslation, Trans } from 'react-i18next'
import * as S from './SectionDepoimentos.styles'

const SectionDepoimentos = () => {
  const { t } = useTranslation()
  const [current, setCurrent] = useState(0)
  const visible = 3

  // Get testimonials from translation
  const testimonials = t('landingV2.sectionDepoimentos.testimonials', {
    returnObjects: true
  }) as Array<{ text: string; author: string; role: string }>

  // Fallback to empty array if translations are not yet loaded properly
  const safeTestimonials = Array.isArray(testimonials) ? testimonials : []
  const total = safeTestimonials.length
  const maxIndex = Math.max(0, total - visible)

  const handleBulletClick = (idx: number) => {
    setCurrent(idx)
  }

  return (
    <S.Section>
      <S.Title>{t('landingV2.sectionDepoimentos.title')}</S.Title>
      <S.CarouselWrapper>
        <S.Carousel>
          {safeTestimonials
            .slice(current, current + visible)
            .map((item, idx) => (
              <S.Card key={idx}>
                <S.Text1>{item.text}</S.Text1>
                <S.Text2>
                  <strong>{item.author}</strong>
                  <br />
                  <Trans
                    i18nKey={`landingV2.sectionDepoimentos.testimonials.${idx + current}.role`}
                    components={{ br: <br /> }}
                  >
                    {item.role}
                  </Trans>
                </S.Text2>
              </S.Card>
            ))}
        </S.Carousel>
        {total > visible && (
          <S.Bullets>
            {Array.from({ length: maxIndex + 1 }).map((_, idx) => (
              <S.Bullet
                key={idx}
                active={idx === current}
                onClick={() => handleBulletClick(idx)}
                aria-label={`Ir para depoimento ${idx + 1}`}
              />
            ))}
          </S.Bullets>
        )}
      </S.CarouselWrapper>
    </S.Section>
  )
}

export default SectionDepoimentos
